import React, { useEffect, useState } from "react";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CartDetails from "../components/Cart/CartDetails";
import BillingDetails from "../components/Billing/BillingDetails";
import CartTotalDetails from "../components/Cart/CartTotalDetails";
import { addProductToCart, getProductsInCart } from "../services/CartServices";
import { useNavigate } from "react-router-dom";
import { addUserAddress, getUserAddress } from "../services/BillingService";
import SubscribeNewsletter from "../components/Cart/SubscribeNewsletter";
import RelatedProducts from "../components/ProductDetails/RelatedProducts";
import { Col, Row } from "react-bootstrap";

const Cart = () => {
  const [cartProduct, setCartProduct] = useState([]);
  const [coupan, setCoupan] = useState("");
  const [couponDetails, setCouponDetails] = useState(null);
  const [discountedPrice, setDiscountedPrice] = useState();
  const [paymentMethod, setPaymentMethod] = useState("cash on delivery");
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);
  const [userAddress, setUserAddress] = useState([]);
  const [addressId, setAddressId] = useState(null);
  const [addNewAddress, setAddNewAddress] = useState("d-none");
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    streetAddress: "",
    state: "",
    city: "",
    pincode: "",
    phoneNumber: Number,
    email: "",
    notes: "",
  });
  const navigate = useNavigate();

  const tokenItem = localStorage.getItem("token");

  const getProductsOfCart = async () => {
    const res = await getProductsInCart(tokenItem);
    setCartProduct(res);
  };

  const removeProduct = async (id) => {
    const quantity = 0;
    const res = await addProductToCart(id, quantity, tokenItem);
    getProductsOfCart();
  };

  const removeAllProduct = async (id) => {
    for (const product of cartProduct) {
      const { _id } = product?.productId;
      const quantity = 0;
      await addProductToCart(_id, quantity, tokenItem);
      getProductsOfCart();
    }
  };

  const updateQuantity = async (id, quantity) => {
    if (tokenItem) {
      const res = await addProductToCart(id, quantity, tokenItem);
      getProductsOfCart();
    } else {
      localStorage.setItem("path", "/cart");
      navigate("/signin");
    }
  };

  const calculateSubTotalPrice = () => {
    let totalPrice = 0;
    cartProduct?.forEach((product) => {
      if (product?.productId?.discountPrice && product?.quantity) {
        totalPrice += product.productId.discountPrice * product.quantity;
      }
    });

    return totalPrice;
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    cartProduct?.forEach((product) => {
      totalPrice += product?.productId?.discountPrice * product?.quantity;
    });
    let discount = 0;

    if (couponDetails && couponDetails.code === coupan) {
      if (couponDetails.type === "percent") {
        discount = totalPrice * (couponDetails.discount / 100);
      } else if (couponDetails.type === "amount") {
        discount = couponDetails.discount;
      }
    }
    const finalTotalPrice = totalPrice - discount;
    return finalTotalPrice;
  };

  const products = cartProduct?.map((value) => {
    return {
      productId: value?.productId?._id,
      quantity: value?.quantity,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

const validateForm = () => {
  const newErrors = {};

  if (!formData.firstName?.trim()) {
    newErrors.firstName = "First Name is required";
  }
  if (!formData.lastName?.trim()) {
    newErrors.lastName = "Last Name is required";
  }
  if (!formData.streetAddress?.trim()) {
    newErrors.streetAddress = "Street Address is required";
  }
  if (!formData.city?.trim()) {
    newErrors.city = "City is required";
  }
  if (!formData.state?.trim()) {
    newErrors.state = "State is required";
  }
  if (!formData.pincode?.trim()) {
    newErrors.pincode = "Pin Code is required";
  } else if (!/^\d{6}$/.test(formData.pincode)) {
    newErrors.pincode = "Enter a valid 6-digit Pin Code";
  }
  if (!formData.phoneNumber?.toString().trim()) {
    newErrors.phoneNumber = "Phone number is required";
  } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
    newErrors.phoneNumber = "Enter a valid 10-digit number";
  }
  if (!formData.email?.trim()) {
    newErrors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = "Enter a valid email";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


const handleSaveAddress = () => {
  if (validateForm()) {
    addAddress(); // Call your original function
  }
};



  const addAddress = async () => {
    const res = await addUserAddress(formData, tokenItem);
    setFormData({
      firstName: "",
      lastName: "",
      companyName: "",
      streetAddress: "",
      state: "",
      city: "",
      pincode: "",
      phoneNumber: Number,
      email: "",
      notes: "",
    });
    window.location.reload();
  };

  const handleAddressSelection = (index, addressId) => {
    setSelectedAddressIndex(index);
    setAddressId(addressId);
  };
  const getAddress = async () => {
    const res = await getUserAddress(tokenItem);
    setUserAddress(res);
  };

  useEffect(() => {
    getAddress();
    getProductsOfCart();
  }, []);

  const productsId = cartProduct?.[0]?.productId?._id;

  useEffect(() => {
    getProductsOfCart();
  }, []);

  return (
    <>
      <CommonNavbar hidebtn="d-none" />
      <div className="bg_clr_light_yellow overflow-hidden">
        <div className="container">
          <Row className="pt-4">
            <Col xl={9}>
              <CartDetails
                calculateTotalPrice={calculateTotalPrice}
                cartProduct={cartProduct}
                updateQuantity={updateQuantity}
                removeAllProduct={removeAllProduct}
                removeProduct={removeProduct}
              />
              <BillingDetails
                userAddress={userAddress}
                formData={formData}
                handleChange={handleChange}
                addAddress={addAddress}
                handleAddressSelection={handleAddressSelection}
                selectedAddressIndex={selectedAddressIndex}
                setSelectedAddressIndex={setSelectedAddressIndex}
                setAddNewAddress={setAddNewAddress}
                addNewAddress={addNewAddress}
                addressId={addressId}
                productsId={productsId}
                  errors={errors}
  handleSaveAddress={handleSaveAddress}
              />
            </Col>
            <Col className=" pe-lg-4" xl={3}>
              <CartTotalDetails
                calculateTotalPrice={() => calculateTotalPrice()}
                calculateSubTotalPrice={() => calculateSubTotalPrice()}
                getProductsOfCart={() => getProductsOfCart()}
                cartProduct={cartProduct}
                discountedPrice={discountedPrice}
                couponDetails={couponDetails}
                setCouponDetails={setCouponDetails}
                setDiscountedPrice={setDiscountedPrice}
                addressId={addressId}
                setCoupan={setCoupan}
                coupan={coupan}
                products={products}
              />
            </Col>
          </Row>
        </div>
        {productsId && (
          <div className="bg-white mt-5">
            <RelatedProducts
              heading="Related"
              heading2="Products"
              display_none="d-none"
              productsId={productsId}
            />
          </div>
        )}
        {/* <div>
          <SubscribeNewsletter />
        </div> */}
        <CommonFooter />
      </div>
    </>
  );
};

export default Cart;
